'use strict'

import 'babel-polyfill'

import 'es6-promise/auto'

import Vue from 'vue'

import App from './App'

import Vuex from 'vuex'

import axios from 'axios'

import VueAxios from 'vue-axios'

import { state } from './store/state'

import { mutations } from './store/mutations'

import Materials from 'vue-materials'

Vue.use(Materials)

Vue.use(VueAxios, axios)

Vue.use(Vuex)

Vue.config.productionTip = false

Vue.axios.defaults.headers.post['Content-Type'] = 'application/json'

let store = new Vuex.Store({
  state,
  mutations
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js